export default "__VITE_ASSET__C04Wyh5Z__"